import React, { Component } from "react"
import AnimatedWrapper from "./../utils/AnimatedWrapper"
import PetInList from "./PetInList"
import { openModal } from "./utils"

class ListOfMyPets extends Component {
  componentDidMount() {
    const { pets } = this.props
    if (pets.length === 0) {
      openModal("welcomeToRubyforniaModal")
    }
  }
  render() {
    const { pets } = this.props

    return (
      <>
        <div className="container controlsBody">
          <h5>Your pack</h5>
          <div className="row">
            {pets &&
              pets.map((pet, index) => {
                return (
                  <div key={index}>
                    <PetInList pet={pet} position={index} showInfo={true} />
                  </div>
                )
              })}
          </div>
        </div>
      </>
    )
  }
}

export default AnimatedWrapper(ListOfMyPets)
// export default ListOfMyPets
